// let api = ''
let api = 'https://bms.jsyixin.com/'

// let api = 'https://plan.jsyixin.com/'
// let api = 'http://xinzhi_sch_pro.jsyixin.com/'
// let api = 'http://xinzhi_plan.jsyixin.com/'
// let api = 'http://192.168.40.96:7777/'
export default api
